<div class="panel-header" (pointerdown)="onHeaderPointerDown($event)" (dblclick)="onHeaderDoubleClick($event)">
  <!-- Double-click the title bar to snap the window home; the tooltip hints at it, but only
       once the window has actually been moved off its default (so it isn't noise at rest). -->
  <div class="title-row" [attr.title]="$canReset() ? 'Double-click to reset window position' : null">
    <span class="title">{{ $headerTitle() }}</span>
    @if (panelService.$newChatOpen()) {
      <w-tag label="TEST" [mode]="BadgeMode.Squared" size="xs" backgroundColor="var(--component-color-alert-warning-background)" color="var(--component-color-alert-warning-text)" borderColor="var(--component-color-alert-warning-border)" />
    }
  </div>
  <div class="header-actions">
    <wb-button-icon [iconLeft]="'fa-regular fa-minus'" [tooltip]="'Minimize'" [displayStyle]="ButtonDisplayStyle.Tertiary" [size]="ButtonSize.Medium" (onClick)="onMinimize()" />
    @if (panelService.$displayMode() === 'popup') {
      <wb-button-icon [iconLeft]="'fa-regular fa-arrow-up-right-and-arrow-down-left-from-center'" [tooltip]="'Expand'" [displayStyle]="ButtonDisplayStyle.Tertiary" [size]="ButtonSize.Medium" (mousedown)="$event.preventDefault()" (onClick)="onExpand()" />
    } @else {
      <wb-button-icon [iconLeft]="'fa-regular fa-arrow-down-left-and-arrow-up-right-to-center'" [tooltip]="'Collapse'" [displayStyle]="ButtonDisplayStyle.Tertiary" [size]="ButtonSize.Medium" (mousedown)="$event.preventDefault()" (onClick)="onCollapse()" />
    }
    <wb-button-icon [iconLeft]="'fa-regular fa-xmark'" [tooltip]="'Close'" [displayStyle]="ButtonDisplayStyle.Tertiary" [size]="ButtonSize.Medium" (onClick)="onClose()" />
  </div>
</div>

<!-- Shown only WHILE the window is being dragged/resized, teaching the double-click-to-reset
     gesture. Rendered as a scrim over the conversation, mirroring the drag-and-drop overlay
     in the chat container. Purely informational, so it never intercepts pointer events —
     the header it refers to stays clickable underneath. -->
@if ($dragging()) {
  <div class="reset-hint" role="status">
    <span>Double-click the header to reset window position</span>
  </div>
}

<div class="panel-body">
  <agent-chat-container [mode]="'popup'" />
</div>
